<mat-toolbar class="footer">
  <span class="fill-remaining-space"></span>
  <span class="text-center">All Rights Reserved 2020 </span>
  <span><img style="width: 12px; height: 12px; padding-top: 13px; padding-left: 5px;" src="./assets/img/favicon.png"></span>
  <span class="text-center">&nbsp;MyAnatomy</span>
  <!-- <span style="margin-left: 10px;"><a href="javascript:void(0)"  class="footer-elements">Disclaimer</a></span>
  <span><a href="javascript:void(0)"  class="footer-elements">Terms</a></span>
  <span><a href="javascript:void(0)"  class="footer-elements">Contact</a></span> -->
  <span><a href="https://myanatomy.in/#/home"  class="footer-elements">About Us</a></span>

  <!-- <span class="fill-remaining-space"></span>
  <button mat-icon-button><i class="material-icons"></i></button>
  <button mat-icon-button><i class="material-icons"></i></button>
  <button mat-icon-button><i class="material-icons"></i></button>
  <button mat-icon-button><i class="material-icons"></i></button> -->
</mat-toolbar>
